// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__-PiNX","loaderBox":"Loader_loaderBox__HXD0N","loader":"Loader_loader__vb63o"};